// 操作日志的类型-新增
export const RecordCreateType = 1;
// 操作日志的类型-删除
export const RecordDeleteType = 2;
// 操作日志的类型-修改
export const RecordUpdateType = 3;

export const RecordTypeId = {
  EMAILRecord: 37, // 邮件审核记录
}

// 时间格式
export const TimeFormatType = {
  date_no_year: "MM-DD",
  date: "YYYY-MM-DD",
  month: "YYYY-MM",
  time: "YYYY-MM-DD HH:mm:ss",
  ch_date_no_year: "MM月DD日",
  ch_date: "YYYY年MM月DD日",
  date_no_split: "YYYYMMDD",
  time_xg: "YYYY/MM/DD HH:mm",
  month_no_split: "YYYYMM",
  date_xg: "YYYY/MM/DD",
  date_point: "YYYY.MM.DD",
}

export const EmailCategory = "EMAIL";
// 垃取待审核列表的状态
export const AuditingStatus = ["Init", "Auditing", "Submmited"];

// 短信状态，签名和短信模版通用
export const EmailStatus = {
  Init: "初始状态",
  Auditing: "审核中",
  Submmited: "已提交",
  AuditSuccess: "审核通过",
  AuditFailed: "审核未通过",
  Disable: "禁用",
  // Delete: "删除"
}

// 模版审核结果可选状态
export const EmailAuditStatus = {
  Auditing: "审核中",
  AuditSuccess: "通过",
  AuditFailed: "未通过",
  Disable: "禁用",
}

// 类型
export const EmailType = {
  // All: '全部',
  Trigger: '触发型',
  Batch: '批量型',
  // All: '通用',
};

// 状态Badge颜色标识
export const EmailStatusStyle = {
  Init: "a-blue",
  Auditing: "a-blue",
  Submmited: "a-blue",
  AuditSuccess: "u-green",
  AuditFailed: "u-red",
  Disable: "u-gray",
  Delete: "u-gray"
}